import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

// 開始2択、交差、3分岐。第1期の菱形合流とは別の骨格。
export const MAP_NODES_HARD = {
  start: node("start", { kind: "start", next: ["a1-lp", "a5-short"], x: 1, y: 0 }),

  "a1-lp": node("a1-lp", { kind: "case", caseId: "a1-lp", next: ["a2-service", "a3-link"], x: 0, y: 1 }),
  "a5-short": node("a5-short", { kind: "case", caseId: "a5-short", next: ["a3-link", "rest-1"], x: 2, y: 1 }),
  "a2-service": node("a2-service", { kind: "case", caseId: "a2-service", next: ["b1-parallel"], x: 0, y: 2 }),
  "a3-link": node("a3-link", { kind: "case", caseId: "a3-link", next: ["a3-inquiry"], x: 1, y: 2 }),
  "rest-1": node("rest-1", { kind: "rest", next: ["a3-inquiry"], x: 2, y: 2 }),
  "b1-parallel": node("b1-parallel", { kind: "case", caseId: "b1-parallel", next: ["rest-2", "a5-release"], x: 0, y: 3 }),
  "a3-inquiry": node("a3-inquiry", { kind: "case", caseId: "a3-inquiry", next: ["a5-release"], x: 2, y: 3 }),
  "rest-2": node("rest-2", { kind: "rest", next: ["b4-platform", "b3-feature"], x: 0, y: 4 }),
  "a5-release": node("a5-release", { kind: "case", caseId: "a5-release", next: ["b3-feature", "b3-change"], x: 2, y: 4 }),

  "b4-platform": node("b4-platform", { kind: "case", caseId: "b4-platform", next: ["b2-link"], x: 0, y: 5 }),
  "b3-feature": node("b3-feature", { kind: "case", caseId: "b3-feature", next: ["rest-3"], x: 1, y: 5 }),
  "b3-change": node("b3-change", { kind: "case", caseId: "b3-change", next: ["b5-delivery"], x: 2, y: 5 }),
  "b2-link": node("b2-link", { kind: "case", caseId: "b2-link", next: ["rest-3"], x: 0, y: 6 }),
  "b5-delivery": node("b5-delivery", { kind: "case", caseId: "b5-delivery", next: ["rest-3"], x: 2, y: 6 }),
  "rest-3": node("rest-3", { kind: "rest", next: ["c2-debt", "c1-overhaul", "c3-release"], x: 1, y: 7 }),

  "c2-debt": node("c2-debt", { kind: "case", caseId: "c2-debt", next: ["c3-incident"], x: 0, y: 8 }),
  "c1-overhaul": node("c1-overhaul", { kind: "case", caseId: "c1-overhaul", next: ["c2-demand"], x: 1, y: 8 }),
  "c3-release": node("c3-release", { kind: "case", caseId: "c3-release", next: ["c4-strategy"], x: 2, y: 8 }),
  "c3-incident": node("c3-incident", { kind: "case", caseId: "c3-incident", next: ["rest-4"], x: 0, y: 9 }),
  "c2-demand": node("c2-demand", { kind: "case", caseId: "c2-demand", next: ["rest-4"], x: 1, y: 9 }),
  "c4-strategy": node("c4-strategy", { kind: "case", caseId: "c4-strategy", next: ["rest-4"], x: 2, y: 9 }),
  "rest-4": node("rest-4", { kind: "rest", next: ["c5-preboss-a"], x: 1, y: 10 }),
  "c5-preboss-a": node("c5-preboss-a", { kind: "case", caseId: "c5-preboss-a", next: ["rest-5"], x: 1, y: 11 }),
  "rest-5": node("rest-5", { kind: "rest", next: ["boss"], x: 1, y: 12 }),
  boss: node("boss", { kind: "case", caseId: "hard-boss", next: [], x: 1, y: 13 }),
} as const satisfies Record<string, NodeDefinition>;
